import { useRef } from "react";

/**
 * Computes a value on the first render and returns it on every subsequent
 * render without re-computing.
 */
export function useInitialValue<T>(fn: () => T): T {
  // Wrap in { value } so that a `null` return from fn() isn't mistaken for
  // "not yet initialized".
  const ref = useRef<{ value: T } | null>(null);

  if (ref.current === null) {
    ref.current = { value: fn() };
  }

  return ref.current.value;
}
